import type { CardSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import ButtonStyled from 'components/Editor/EditorElements/courseKit/DropdownMenuCourse/styled/ButtonStyled'
import type { ElementStyleCss } from 'services/Branding/types'

import IconStyled from './IconStyled'

const ElementRootStyled = styled(ButtonStyled)<{
  $styles: ElementStyleCss<CardSchemaType>
  $noHover: boolean
  $isV2?: boolean
}>`
  max-width: 100%;
  background-color: transparent;
  background-color: var(--color-background-main);
  perspective: 1000px;
  width: ${({ $styles }) => $styles.card.width};
  height: ${({ $styles }) => $styles.card.height};
  border-radius: ${({ $styles }) => $styles.card.borderRadius};

  &:hover ${IconStyled} {
    background-color: ${({ $styles, $noHover }) => !$noHover && $styles.hover.backgroundColor};
  }

  ${({ $isV2 }) =>
    $isV2 &&
    css`
      width: 100%;
      height: 100%;
    `};
`

export default ElementRootStyled
